module.exports = __webpack_public_path__ + "img/view-list.baf27f54.svg";